<template>
  <div id="edit_history">
    <div class="page-header header-filter" data-parallax="true" style="background-image: url('static/img/history.jpg'); height:50vh" >
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <div class="brand text-center">
              <h1>(編輯)發展里程碑</h1>
              <h3 class="title text-center">(Edit)Milestone</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
        <div class="container">
            <div class="progress" style="height: 10px;" v-if="prossVal !=0">
                <div class="progress-bar" role="progressbar" :style="{width: prossVal + '%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{prossVal}}%</div>
            </div>
            <div class="section">
                <button class="btn btn-social btn-fill btn-behance" @click="save_data">
                    <span class="material-icons mr-2">save_alt</span> 儲存
                </button>
                <button class="btn btn-social btn-fill btn-tumblr" @click="cancel_edit">
                    <span class="material-icons mr-2">keyboard_return</span> 取消編輯
                </button>
                <button class="btn btn-social btn-fill btn-twitter" @click="add_title">
                    <span class="material-icons mr-2">control_point</span> 增加新大標
                </button>
                <template v-if="data.length > 0">
                    <template v-for="(item, index) in data">
                        <table class="table table-bordered" :key="index">
                            <thead class="thead-light">
                                <tr>
                                    <th>中文標題：
                                        <input type="text" class="form-control" v-model="item.title_cht" v-if="item.del == 0">
                                        <input type="text" class="form-control text-danger font-italic" v-model="item.title_cht" readonly v-else>
                                    </th>
                                    <th>英文標題：
                                        <input type="text" class="form-control" v-model="item.title_eng" v-if="item.del == 0">
                                        <input type="text" class="form-control text-danger font-italic" v-model="item.title_eng" readonly v-else>
                                    </th>
                                    <th>標題圖片名稱：
                                        <!-- <input type="text" class="form-control" v-model="item.title_pic" v-if="item.del == 0">
                                        <input type="text" class="form-control text-danger font-italic" v-model="item.title_pic" readonly v-else> -->
                                        <template v-if="item.del == 0">
                                            <img style="width:10%;" :src="item.title_pic" />
                                            <label class="btn btn-info">
                                                <input type="file" class="custom-file-input" style="display: none;" id="img-upload" accept="image/*" @change="uploadImg($event, index)" />
                                                <i class="fa fa-photo"></i> 上傳圖片
                                            </label>
                                        </template>
                                    </th>
                                    <th>
                                        <button v-if="item.del == 0" class="btn btn-link btn-twitter" @click="title_del(index)">
                                            <span class="material-icons mr-2">remove_circle_outline</span>刪除大標題
                                        </button>
                                        <button v-else class="btn btn-link btn-twitter" @click="title_cancel_del(index)">
                                            <span class="material-icons mr-2">delete_sweep</span>取消刪除
                                        </button>
                                        <button  class="btn btn-link btn-facebook" data-toggle="collapse" :data-target="'.title' + index">
                                            <span class="material-icons mr-2">list</span>摺疊
                                        </button>
                                    </th>
                                </tr>
                            </thead>
                            <template v-for="(sub_item, sub_index) in item.list">
                                <!-- <tr :key="sub_item.id" :class="['title' + index + ' collapse', index == 0 ? 'show':'in']"> -->
                                <tr :key="sub_item.id" :class="'title' + index" class="collapse show">
                                    <td>
                                        <button v-if="sub_item.del == 0" class="btn btn-link btn-twitter" @click="list_del(index, sub_index)">
                                            <span class="material-icons mr-2">remove_circle_outline</span>刪除清單
                                        </button>
                                        <button v-else class="btn btn-link btn-twitter" @click="list_cancel_del(index, sub_index)">
                                            <span class="material-icons mr-2">delete_sweep</span>取消刪除
                                        </button>
                                    </td>
                                    <td colspan="3">
                                        <div v-if="sub_item.del == 0">
                                            年代：<input type="text" class="form-control" v-model="sub_item.years" placeholder="年代"><br>
                                            中文描述：<input type="text" class="form-control" v-model="sub_item.description.cht" placeholder="中文描述"><br>
                                            英文描述：<input type="text" class="form-control" v-model="sub_item.description.eng" placeholder="英文描述">
                                        </div>
                                        <div v-else>
                                            年代：<input type="text" class="form-control text-danger font-italic" v-model="sub_item.years" placeholder="年代" readonly><br>
                                            中文描述：<input type="text" class="form-control text-danger font-italic" v-model="sub_item.description.cht" placeholder="中文描述" readonly><br>
                                            英文描述：<input type="text" class="form-control text-danger font-italic" v-model="sub_item.description.eng" placeholder="英文描述" readonly>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <tr>
                                <td colspan="4">
                                    <button class="btn btn-social btn-fill btn-twitter" @click="add_sub_list(index)">
                                        <span class="material-icons mr-2">control_point</span> 增加清單
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </template>
                </template>
                
                <button class="btn btn-social btn-fill btn-behance" @click="save_data">
                    <span class="material-icons mr-2">save_alt</span> 儲存
                </button>
                <button class="btn btn-social btn-fill btn-tumblr" @click="cancel_edit">
                    <span class="material-icons mr-2">keyboard_return</span> 取消編輯
                </button>
                <button class="btn btn-social btn-fill btn-twitter" @click="add_title">
                    <span class="material-icons mr-2">control_point</span> 增加新大標
                </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import EXIF from "exif-js";

export default {
  name: "edit_history",
  props: [],
  data() {
    return {
      data:[],
      imgFile: [],
      imgNumLimit: 1,
      imgString: [],
      prossVal: 0     // 進度條顯示
    };
  },
  methods: {
    gethistoryInfo: function(){
      var vm = this;
        // console.log('gethistoryInfo');
      var data = [];
       axios
          .get(`/api/gethistoryInfo`)
          .then(res => {
            // console.log(res.data);
            data = res.data.data;

            for(var i = 0; i < data.length; i++){
                var title_queue = data[i].title_queue;
                if( i == 0 ){
                    vm.data.push({
                        title_queue: data[i].title_queue,
                        title_cht: data[i].title_cht,
                        title_eng: data[i].title_eng,
                        title_pic: data[i].img,
                        del:0,
                        list:[{
                            id: data[i].id,
                            sub_queue: data[i].sub_queue,
                            years: data[i].years,
                            del:0,
                            description:{
                                cht: data[i].description_cht,
                                eng: data[i].description_eng
                            }
                        }]
                    });
                }
                else{
                    var data_len = vm.data.length;

                    if(title_queue == data[i-1].title_queue){
                        vm.data[data_len - 1].list.push({
                            id: data[i].id,
                            sub_queue: data[i].sub_queue,
                            years: data[i].years,
                            del:0,
                            description:{
                                cht: data[i].description_cht,
                                eng: data[i].description_eng
                            }
                        });
                    }
                    else{
                        vm.data.push({
                            title_queue: data[i].title_queue,
                            title_cht: data[i].title_cht,
                            title_eng: data[i].title_eng,
                            title_pic: data[i].img,
                            del:0,
                            list:[{
                                id: data[i].id,   
                                sub_queue: data[i].sub_queue,
                                years: data[i].years,
                                del:0,
                                description:{
                                    cht: data[i].description_cht,
                                    eng: data[i].description_eng
                                }
                            }]
                        });
                    }
                }
            }
          })
          .catch(err => {
            console.log(err);
          });
        
    },
    title_del: function(index){
        this.data[index].del = 1;
        // 讓小標都標示為刪除
        for(var i = 0; i < this.data[index].list.length; i++){
            this.data[index].list[i].del = 1;
        }
    },
    title_cancel_del: function(index){
        this.data[index].del = 0;
        // 讓小標都標示為未刪除
        for(var i = 0; i < this.data[index].list.length; i++){
            this.data[index].list[i].del = 0;
        }
    },
    list_del: function(index, sub_index){
        this.data[index].list[sub_index].del = 1;
    },
    list_cancel_del: function(index, sub_index){
        // 如果大標題都被刪除，小標題無法個別取消刪除
        if(this.data[index].del != 1){
            this.data[index].list[sub_index].del = 0;
        }
        else{
            alert('大標題已被標示為刪除');
        }
    },
    add_title: function(){
        var data_title_len = this.data.length;
        // var last_queue = this.data[data_title_len -1].title_queue;
        var last_queue = this.data[0].title_queue;

        this.data.unshift({
            title_queue: last_queue + 1,
            title_cht: '',
            title_eng: '',
            title_pic: '',
            del:0,
            list:[{
                id: null,
                sub_queue: 1,
                years: '',
                del:0,
                description:{
                    cht: '',
                    eng: ''
                }
            }]
        });

    },
    add_sub_list: function(index){
        var data_list_len = this.data[index].list.length;
        // var last_queue = this.data[index].list[data_list_len - 1].sub_queue;
        var last_queue = this.data[index].list[0].sub_queue;
        
        this.data[index].list.push({
            id: null,
            sub_queue: last_queue + 1,
            years: '',
            del:0,
            description:{
                cht: '',
                eng: ''
            }
        });
    },
    async save_data(){
        var vm = this;
        var save_data = [];
        
        for(var i = 0 ; i < this.data.length; i++){
            var data_del = this.data[i].del
            var sub_list = this.data[i].list;
            
            for(var j = 0; j < sub_list.length; j++){
                // save_data.push({
                //     id: sub_list[j].id,
                //     title_queue: this.data[i].title_queue,
                //     sub_queue: sub_list[j].sub_queue,
                //     years: sub_list[j].years,
                //     title_cht: this.data[i].title_cht,
                //     title_eng: this.data[i].title_eng,
                //     img: this.data[i].title_pic,
                //     description_cht: sub_list[j].description.cht,
                //     description_eng: sub_list[j].description.eng,
                //     title_del: this.data[i].del,
                //     list_del: sub_list[j].del
                // })
                
                await vm.savehistory({
                    id: sub_list[j].id,
                    title_queue: this.data[i].title_queue,
                    sub_queue: sub_list[j].sub_queue,
                    years: sub_list[j].years,
                    title_cht: this.data[i].title_cht,
                    title_eng: this.data[i].title_eng,
                    img: this.data[i].title_pic,
                    pic: this.data[i].title_eng,                    // 雖然沒用，但還是要存值，不然會壞
                    description_cht: sub_list[j].description.cht,
                    description_eng: sub_list[j].description.eng,
                    title_del: this.data[i].del,
                    list_del: sub_list[j].del
                })
            }
            // 顯示進度條顯示進度條
            vm.prossVal = Math.floor(( i / this.data.length )*100);

        }

        vm.$router.push("/about/history");

        // axios
        //   .post(`${process.env.API_PATH}/api/savehistoryInfo`,save_data)
        //   .then(res => {
        //     // console.log(res);
        //     if(res.status == 200)
        //         vm.$router.push("/about/history");
        //   })
        //   .catch(err => {
        //     console.log(err);
        //   });
    },
    // 儲存
    async savehistory(save_data){
        var vm = this;
                
        return new Promise(resolve => {
            axios
              .post(`/api/savehistoryInfo`,save_data)
              .then(res => {                  
                  resolve();  // 表示完成
              })
              .catch(err => {
                  console.log(err);
              });
        });
    },

    cancel_edit: function(){
        this.$router.push("/about/history");
    },
    uploadImg: function(e, index) {      
      let tag = e.target;
      let fileList = tag.files;
      let imgNum = fileList.length;
      let _this = this;
      _this.imgString = [];   //圖片資料清零
      _this.imgFile = [];     //圖片資料清零
      if (imgNum > this.imgNumLimit) {
        alert("一次最多上傳" + this.imgNumLimit + "張圖片！");
        return;
      }
      var Orientation;
      for (let i = 0; i < imgNum; i++) {
        _this.imgFile.push(fileList[i]);
        EXIF.getData(fileList[i], function() {
          Orientation = EXIF.getTag(fileList[i], "Orientation");
        });
        // file to base64
        let reader = new FileReader();
        reader.readAsDataURL(fileList[i]);
        reader.onload = function() {
          var oReader = new FileReader();
          oReader.onload = function(e) {
            var image = new Image();
            image.src = e.target.result;
            image.onload = function() {

              var expectWidth = this.naturalWidth;
              var expectHeight = this.naturalHeight;
              if (
                this.naturalWidth > this.naturalHeight &&
                this.naturalWidth > 800
              ) {
                expectWidth = 800;
                expectHeight =
                  (expectWidth * this.naturalHeight) / this.naturalWidth;
              } else if (
                this.naturalHeight > this.naturalWidth &&
                this.naturalHeight > 1200
              ) {
                expectHeight = 1200;
                expectWidth =
                  (expectHeight * this.naturalWidth) / this.naturalHeight;
              }
              var canvas = document.createElement("canvas");
              var ctx = canvas.getContext("2d");
              canvas.width = expectWidth;
              canvas.height = expectHeight;
              ctx.drawImage(this, 0, 0, expectWidth, expectHeight);


              var base64 = null;

              base64 = canvas.toDataURL("image/jpeg", 0.8);

              _this.imgString.push({ src: base64 });
              
             _this.data[index].title_pic = _this.imgString[0].src;
              // console.log(JSON.stringify(_this.imgString));
            };
          };
          oReader.readAsDataURL(fileList[i]);
        };
      }
    },
  },
  filters: {
    imgUrl: function(value) {
      if(value != null){
        value = "/static/img/icons/" + value + ".png";        
      }
      else{
        value = "/static/img/placeholder.jpg";
      }
      
      return value;
    }
  },
  computed: {},
  created() {
      this.gethistoryInfo();
  },
  mounted() {},
  components: {},
  watch: {}
};
</script>

<style scoped>
.cbp_tmtimeline {
    margin: 0;
    padding: 0;
    list-style: none;
    position: relative
}

.cbp_tmtimeline:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 3px;
    background: #eee;
    left: 20%;
    margin-left: -6px
}

.cbp_tmtimeline>li {
    position: relative
}

.cbp_tmtimeline>li:first-child .cbp_tmtime span.large {
    color: #444;
    font-size: 17px !important;
    font-weight: 700
}

.cbp_tmtimeline>li:first-child .cbp_tmicon {
    background: #fff;
    color: #666
}

.cbp_tmtimeline>li:nth-child(odd) .cbp_tmtime span:last-child {
    color: #444;
    font-size: 13px
}

.cbp_tmtimeline>li:nth-child(odd) .cbp_tmlabel {
    background: #f0f1f3
}

.cbp_tmtimeline>li:nth-child(odd) .cbp_tmlabel:after {
    border-right-color: #f0f1f3
}

.cbp_tmtimeline>li .empty span {
    color: #777
}

.cbp_tmtimeline>li .cbp_tmtime {
    display: block;
    width: 23%;
    padding-right: 70px;
    position: absolute
}

.cbp_tmtimeline>li .cbp_tmtime span {
    display: block;
    text-align: right
}

.cbp_tmtimeline>li .cbp_tmtime span:first-child {
    font-size: 15px;
    color: #3d4c5a;
    font-weight: 700
}

.cbp_tmtimeline>li .cbp_tmtime span:last-child {
    font-size: 14px;
    color: #444
}

.cbp_tmtimeline>li .cbp_tmlabel {
    margin: 0 0 15px 25%;
    background: #f0f1f3;
    padding: 1.2em;
    position: relative;
    border-radius: 5px
}

.cbp_tmtimeline>li .cbp_tmlabel:after {
    right: 100%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-right-color: #f0f1f3;
    border-width: 10px;
    top: 10px
}

.cbp_tmtimeline>li .cbp_tmlabel blockquote {
    font-size: 16px
}

.cbp_tmtimeline>li .cbp_tmlabel .map-checkin {
    border: 5px solid rgba(235, 235, 235, 0.2);
    -moz-box-shadow: 0px 0px 0px 1px #ebebeb;
    -webkit-box-shadow: 0px 0px 0px 1px #ebebeb;
    box-shadow: 0px 0px 0px 1px #ebebeb;
    background: #fff !important
}

.cbp_tmtimeline>li .cbp_tmlabel h2 {
    margin: 0px;
    padding: 0 0 10px 0;
    line-height: 26px;
    font-size: 16px;
    font-weight: normal
}

.cbp_tmtimeline>li .cbp_tmlabel h2 a {
    font-size: 15px
}

.cbp_tmtimeline>li .cbp_tmlabel h2 a:hover {
    text-decoration: none
}

.cbp_tmtimeline>li .cbp_tmlabel h2 span {
    font-size: 15px
}

.cbp_tmtimeline>li .cbp_tmlabel p {
    color: #444
}

.cbp_tmtimeline>li .cbp_tmicon {
    width: 40px;
    height: 40px;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    font-size: 1.4em;
    line-height: 40px;
    -webkit-font-smoothing: antialiased;
    position: absolute;
    color: #fff;
    /* background: #46a4da; */
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 0 0 5px #f5f5f6;
    text-align: center;
    left: 20%;
    top: 0;
    margin: 0 0 0 -25px
}

@media screen and (max-width: 992px) and (min-width: 768px) {
    .cbp_tmtimeline>li .cbp_tmtime {
        padding-right: 60px
    }
}

@media screen and (max-width: 65.375em) {
    .cbp_tmtimeline>li .cbp_tmtime span:last-child {
        font-size: 12px
    }
}

@media screen and (max-width: 47.2em) {
    .cbp_tmtimeline:before {
        display: none
    }
    .cbp_tmtimeline>li .cbp_tmtime {
        width: 100%;
        position: relative;
        padding: 0 0 20px 0
    }
    .cbp_tmtimeline>li .cbp_tmtime span {
        text-align: left
    }
    .cbp_tmtimeline>li .cbp_tmlabel {
        margin: 0 0 30px 0;
        padding: 1em;
        font-weight: 400;
        font-size: 95%
    }
    .cbp_tmtimeline>li .cbp_tmlabel:after {
        right: auto;
        left: 20px;
        border-right-color: transparent;
        border-bottom-color: #f5f5f6;
        top: -20px
    }
    .cbp_tmtimeline>li .cbp_tmicon {
        position: relative;
        float: right;
        left: auto;
        margin: -64px 5px 0 0px
    }
    .cbp_tmtimeline>li:nth-child(odd) .cbp_tmlabel:after {
        border-right-color: transparent;
        border-bottom-color: #f5f5f6
    }
}

.bg-green {
    background-color: #50d38a !important;
    color: #fff;
}

.bg-blush {
    background-color: #ff758e !important;
    color: #fff;
}

.bg-orange {
    background-color: #ffc323 !important;
    color: #fff;
}

.bg-info {
    background-color: #2CA8FF !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/about/edit_history.vue